import { BeneficiaryInsightWidgetDTO } from '@repo/shared/dtos/beneficiary'
import { useT } from '@repo/ui/hooks'
import { Switch } from '@repo/ui/switch'
import { ColumnDef } from '@tanstack/react-table'

import {
  getComputedInsightWidget,
  toggleWidgetDisplayInDashboard,
} from '@/store/beneficiary-insights/thunks'
import { useStoreDispatch } from '@/store/hooks'

import { DataTableColumnHeader } from '../../members/ColHeader'
import { Actions } from './Actions'
import { getInsightWidgetIcon } from './helpers'

export const columns: ColumnDef<BeneficiaryInsightWidgetDTO>[] = [
  {
    id: 'title',
    accessorKey: 'title',
    header: ({ column }) => {
      const { t } = useT({ keyPrefix: 'admin.insights.list.columns' })
      return (
        <DataTableColumnHeader
          title={t('title')}
          column={column}
          options={{ sortable: false, searchable: false }}
        />
      )
    },
    cell: ({ row }) => {
      const dispatch = useStoreDispatch()
      return (
        <div
          className="flex items-center gap-4 cursor-pointer"
          onClick={() => void dispatch(getComputedInsightWidget({ widget: row.original }))}
        >
          {getInsightWidgetIcon(row.original)}
          <div>
            <p className="text-md font-medium">{row.original.title}</p>
            <p className="text-sm text-primary/50">{row.original.description}</p>
          </div>
        </div>
      )
    },
  },
  {
    id: 'displayInDashboard',
    accessorKey: 'displayInDashboard',
    header: ({ column }) => {
      const { t } = useT({ keyPrefix: 'admin.insights.list.columns' })
      return <DataTableColumnHeader title={t('displayInDashboard')} column={column} />
    },
    cell: ({ row }) => {
      const dispatch = useStoreDispatch()

      const handleChange = () => {
        void dispatch(toggleWidgetDisplayInDashboard({ widgetId: row.original.id }))
      }

      return (
        <Switch checked={row.original.displayInDashboard} onCheckedChange={() => handleChange()} />
      )
    },
  },
  {
    id: 'createdBy',
    accessorKey: 'caseWorker',
    header: ({ column }) => {
      const { t } = useT({ keyPrefix: 'admin.insights.list.columns' })
      return <DataTableColumnHeader title={t('createdBy')} column={column} />
    },
    cell: ({ row }) => {
      return (
        <p>
          {row.original.caseWorker.firstName} {row.original.caseWorker.lastName}
        </p>
      )
    },
  },
  {
    id: 'actions',
    cell: ({ row }) => {
      return <Actions widget={row.original} />
    },
  },
]
